module.exports = __webpack_public_path__ + "static/img/manual-21.5ab80c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-21.png
// module id = tgye
// module chunks = 4